import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { TabContainer } from "../../components/SocialCaseTbas/Social.styled";
import { useEffect, useState } from "react";
import General from "../../stores/GeneralStore";
import { Document } from "../../components/Temporary Components/SocialCaseModal.styled";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import trashIcon from "../../assets/trash.svg";
import { ChangeEvent } from "react";
import { NotifyError } from "../../utils/ShowError";
import { set } from "mobx";

interface FileUpload {
  mediaType: string;
  fileName: string;
  buffer: string;
}

const FileUpload = observer(
  ({
    onSubmit,
    submitLoader,
    Previous
  }: {
    onSubmit: (
      files: any,
      additionFileCount: number,
      tenanacyContractFileCount: number
    ) => Promise<void>;
    submitLoader: Boolean;
    Previous?: () => void;
  }) => {
    const contrast = General?.contrast;
    const ColorAss = General?.ColorAss;

    const [uploadedFiles, setUploadedFiles] = useState<any>([]);
    const [showLoader, setShowLoader] = useState(false);
    const [tenantAttachmentCount, setTenantAttachmentCount] = useState(1);
    const [additionFileCount, setAdditionFileCount] = useState(0);

    useEffect(() => {
      console.log("uploadedFiles", uploadedFiles);
    }, [uploadedFiles]);
    const [validationErrors, setValidationErrors] = useState<{
      [key: string]: boolean;
    }>({});

    const mandatoryDocumentsInitialState = [
      {
        key: "courtcaseletter",
        label: General?.codeLabels["cm_court_case_letter"]?.label,
      },
      {
        key: "policereport",
        label: General?.codeLabels["cm_police_report"]?.label,
      },
      {
        key: "ownercopy",
        label: General?.codeLabels["cm_copy_owner_id"]?.label,
      },
      {
        key: "emirateid",
        label: General?.codeLabels["cm_emirate_td_id"]?.label,
      },
      {
        key: "poadoc",
        label: General?.codeLabels["cm_poa_document"]?.label,
      },
      {
        key: "tenancycontract1",
        label: `${General?.codeLabels["cm_tenancy_contract_copy"]?.label}_${1}`,
      },
     
      
    ];

    const [mandatoryDocuments, setMandatoryDocuments] = useState(
      mandatoryDocumentsInitialState
    );
    const addMoreDocuments = () => {
      const newDocument = {
        key: `newDocument${mandatoryDocuments.length}`,
        label: General?.codeLabels["cm_application_documents"]?.label,
      };
      setMandatoryDocuments([...mandatoryDocuments, newDocument]);
      setAdditionFileCount((prev) => prev + 1);
    };

    const handleRemoveField = (key: string) => {
      console.log(key);
      const documents = mandatoryDocuments.filter((d) => d.key != key);
      setMandatoryDocuments(documents);
      setAdditionFileCount((prev) => prev - 1);

      setValidationErrors((prevErrors) => {
        const { [key]: _, ...rest } = prevErrors;
        return rest;
      });
    };

    const handleUploadFileChange = async (
      event: ChangeEvent<HTMLInputElement>,
      inputName: string,
      key: string
    ) => {
      const files: FileList | null = event.target.files;
      if (!files || files.length === 0) return;

      const file: File = files[0]; // Only take the first file

      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/jpg",
        "image/png",
      ];

      if (!allowedTypes.includes(file.type)) {
        NotifyError(
          General?.codeLabels["cm_complaint_error"]?.label !== undefined
            ? General?.codeLabels["cm_complaint_error"]?.label
            : "Only PDF, JPEG, JPG and PNG files are allowed"
        );
        return;
      }

      try {
        const fileUpload = await new Promise<FileUpload>((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const result = reader.result as string;
            const buffer = result.split(",")[1]; // ✅ SAFE way
            const fileName = `${inputName}_${file.name}`;
            const mediaType = file.type;
            resolve({ mediaType, fileName, buffer });
          };
          reader.onerror = reject;
        });

        setUploadedFiles((prev: any) => ({
          ...prev,
          [inputName]: fileUpload, // Replace existing file for this input
        }));

        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [inputName]: false,
        }));
      } catch (error) {
        console.log("Error while processing file upload:", error);
        NotifyError(General?.codeLabels["cm_complaint_error"]?.label);
      }
    };

    const handleSubmit = () => {
      const missingMandatoryDocuments = mandatoryDocuments.filter(
        (doc) => !uploadedFiles[doc.key]
      );

      if (missingMandatoryDocuments.length > 0) {
        const newErrors: { [key: string]: boolean } = {};
        missingMandatoryDocuments.forEach((doc) => {
          newErrors[doc.key] = true;
        });
        setValidationErrors(newErrors);
        return;
      }
      setShowLoader(true);
      onSubmit(uploadedFiles, additionFileCount, tenantAttachmentCount);
    };

    const renderTenantAttachmentFields = () => {
      if (tenantAttachmentCount <= 0) {
        return null;
      }

      return Array.from({ length: tenantAttachmentCount }).map((_, index) => {
        const docKey = `tenancycontract${index + 1}`;
        const docLabel = General?.codeLabels["cm_tenancy_contract_copy"]?.label
          ? `${General?.codeLabels["cm_tenancy_contract_copy"]?.label}_${index + 1}`
          : `Copy of Tenant ${index + 1}`;
        if(index === 0) return null; // Skip the first tenant attachment field
        return (
          <div key={docKey}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                }}
              >
                <Document
                  exists={uploadedFiles[docKey] !== undefined}
                  mainText={docLabel}
                  subText={uploadedFiles[docKey]?.name || "Optional Document"}
                  onChange={(e) => {
                    handleUploadFileChange(e, docKey, docLabel);
                  }}
                  inputName={docKey}
                  name={uploadedFiles[docKey]?.fileName}
                  label={docKey}
                  key={`${docKey}-${uploadedFiles[docKey]?.fileName || ""}`}
                  dispute={true}
                  acceptFileType={
                    "application/pdf, image/jpeg, image/jpg, image/png"
                  }
                />
              </div>
              <div>
                {uploadedFiles[docKey] && (
                  <button
                    type="button"
                    style={{
                      cursor: "pointer",
                      background: "none",
                      border: 0,
                    }}
                    onClick={() => {
                      setUploadedFiles((prev: any) => {
                        const newFiles = { ...prev };
                        delete newFiles[docKey];
                        return newFiles;
                      });
                    }}
                  >
                    <img src={trashIcon} alt="Remove Attachment" />
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      });
    };

    return (
      <>
        <TabContainer
          style={{
            flexDirection: "column",
            display: General?.isLargeScreen ? "" : "flex",
          }}
        >
          <p
            style={{
              gridColumn: "1 / span 2",
              paddingTop: "10px",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "20px",
              color: General?.contrast?.contrastColor
                ? General?.contrast?.contrastColor
                : General?.ColorAss,
            }}
          >
            {General?.codeLabels["cm_pdc_all"]?.label
              ? General?.codeLabels["cm_pdc_all"]?.label
              : "Upload all mandatory documents and use optional documents feature for any supporting documents"}
          </p>
          {mandatoryDocuments
            .filter(
              (doc) =>
                doc.label !== General?.codeLabels["cm_application_documents"]?.label
            )
            .map((doc,index) => {
              if(index === 5 ) return null; // Skip the "Copy of Tenant 1" document in the mandatory section
              return(
              <div key={doc.key}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Document
                      exists={uploadedFiles[doc.key] !== undefined}
                      mainText={doc.label}
                      subText={
                        uploadedFiles[doc.key]?.name ||
                        General?.codeLabels["cm_mandatory_document"]?.label ||
                        "Mandatory Document"
                      }
                      onChange={(e) => {
                        handleUploadFileChange(e, doc.key, doc?.label);
                      }}
                      inputName={doc.key}
                      name={uploadedFiles[doc.key]?.fileName}
                      label={doc?.key}
                      key={`${doc.key}-${uploadedFiles[doc.key]?.fileName || ""}`}
                      dispute={true}
                      acceptFileType={
                        "application/pdf, image/jpeg, image/jpg, image/png"
                      }
                    />
                    {validationErrors[doc.key] && (
                      <p
                        style={{
                          color: "red",
                          margin: "4px 0 0 0",
                          fontWeight: "bold",
                        }}
                      >
                        {General?.codeLabels["cm_socialcasenofileerr"]?.label
                          ? General?.codeLabels["cm_socialcasenofileerr"]?.label
                          : "Please upload file for"}{" "}
                        {doc.label}
                      </p>
                    )}
                  </div>
                  <div>
                    {uploadedFiles[doc.key] && (
                      <button
                        type="button"
                        style={{
                          cursor: "pointer",
                          background: "none",
                          border: 0,
                        }}
                        onClick={() => {
                          setUploadedFiles((prev: any) => {
                            const newFiles = { ...prev };
                            delete newFiles[doc.key];
                            return newFiles;
                          });
                        }}
                      >
                        <img src={trashIcon} alt="Remove Attachment" />
                      </button>
                    )}
                  </div>
                </div>
              </div>)
  })}
          <div style={{ gridColumn: "1 / span 2" }}>
            <Label>
              {General?.codeLabels["cm_no_of_tenant_attachments"]?.label ||
                "No of Tenant Attachment Documents"}
            </Label>
            <select
              value={tenantAttachmentCount}
              onChange={(e) => {
                const count = parseInt(e.target.value, 10);
                setTenantAttachmentCount(isNaN(count) ? 1 : count);
              }}
              style={{
                width: "30%",
                height: "40px",
                padding: "0 10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor
                  ? contrast?.contrastBackground
                  : ColorAss,
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#edf4f6",
              }}
            >
              {Array.from({ length: 5 }, (_, i) => i + 1).map((number) => (
                <option key={number} value={number}>
                  {number}
                </option>
              ))}
            </select>
          </div>
           {mandatoryDocuments
            .filter(
              (doc) =>
                doc.label !== General?.codeLabels["cm_application_documents"]?.label
            ).slice(5, 6) // Only show the first 5 mandatory documents
            .map((doc,index) => {
              return(
              <div key={doc.key}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Document
                      exists={uploadedFiles[doc.key] !== undefined}
                      mainText={doc.label}
                      subText={
                        uploadedFiles[doc.key]?.name ||
                        General?.codeLabels["cm_mandatory_document"]?.label ||
                        "Mandatory Document"
                      }
                      onChange={(e) => {
                        handleUploadFileChange(e, doc.key, doc?.label);
                      }}
                      inputName={doc.key}
                      name={uploadedFiles[doc.key]?.fileName}
                      label={doc?.key}
                      key={`${doc.key}-${uploadedFiles[doc.key]?.fileName || ""}`}
                      dispute={true}
                      acceptFileType={
                        "application/pdf, image/jpeg, image/jpg, image/png"
                      }
                    />
                    {validationErrors[doc.key] && (
                      <p
                        style={{
                          color: "red",
                          margin: "4px 0 0 0",
                          fontWeight: "bold",
                        }}
                      >
                        {General?.codeLabels["cm_socialcasenofileerr"]?.label
                          ? General?.codeLabels["cm_socialcasenofileerr"]?.label
                          : "Please upload file for"}{" "}
                        {doc.label}
                      </p>
                    )}
                  </div>
                  <div>
                    {uploadedFiles[doc.key] && (
                      <button
                        type="button"
                        style={{
                          cursor: "pointer",
                          background: "none",
                          border: 0,
                        }}
                        onClick={() => {
                          setUploadedFiles((prev: any) => {
                            const newFiles = { ...prev };
                            delete newFiles[doc.key];
                            return newFiles;
                          });
                        }}
                      >
                        <img src={trashIcon} alt="Remove Attachment" />
                      </button>
                    )}
                  </div>
                </div>
              </div>)
  })}
          {renderTenantAttachmentFields()}

          {/* Optional documents (add more) only after tenant contract */}
          {mandatoryDocuments
            .filter(
              (doc) =>
                doc.label === General?.codeLabels["cm_application_documents"]?.label
            )
            .map((doc) => (
              <div key={doc.key}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "90%" }}>
                    <Document
                      exists={uploadedFiles[doc.key] !== undefined}
                      mainText={doc.label}
                      subText={
                        uploadedFiles[doc.key]?.name ||
                        General?.codeLabels["cm_mandatory_document"]?.label ||
                        "Mandatory Document"
                      }
                      onChange={(e) => {
                        handleUploadFileChange(e, doc.key, doc?.label);
                      }}
                      inputName={doc.key}
                      name={uploadedFiles[doc.key]?.fileName}
                      label={doc?.key}
                      key={`${doc.key}-${uploadedFiles[doc.key]?.fileName || ""}`}
                      dispute={true}
                      acceptFileType={
                        "application/pdf, image/jpeg, image/jpg, image/png"
                      }
                    />
                    {validationErrors[doc.key] && (
                      <p
                        style={{
                          color: "red",
                          margin: "4px 0 0 0",
                          fontWeight: "bold",
                        }}
                      >
                        {General?.codeLabels["cm_socialcasenofileerr"]?.label
                          ? General?.codeLabels["cm_socialcasenofileerr"]?.label
                          : "Please upload file for"}{" "}
                        {doc.label}
                      </p>
                    )}
                  </div>
                  <div>
                    {(uploadedFiles[doc.key] ||
                      doc.label ===
                        General?.codeLabels["cm_application_documents"]?.label) && (
                      <button
                        type="button"
                        style={{
                          cursor: "pointer",
                          background: "none",
                          border: 0,
                        }}
                        onClick={() => {
                          handleRemoveField(doc.key);
                        }}
                      >
                        <img src={trashIcon} alt="Remove Attachment" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          <Label>
            <div
              style={{
                height: "43px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ButtonSecondary
                style={{
                  alignSelf: "end",
                  width: General?.isLargeScreen ? "205px" : "98%",
                  height: "36px",
                  background: General?.contrast?.contrastBackground
                    ? General?.contrast?.contrastBackground
                    : "#FFFFFF",
                  border: General?.contrast?.contrastColor
                    ? `1px solid ${General?.contrast?.contrastColor}`
                    : " 1px solid #101E8E",
                  fontWeight: "900",
                  padding: "10px 0",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  lineHeight: "16px",
                  color: General?.contrast?.contrastColor
                    ? General?.contrast?.contrastColor
                    : General?.ColorAss,
                  // marginBottom: "12px"
                }}
                onClick={addMoreDocuments}
              >
                {General?.codeLabels["cm_add_more"]?.label
                  ? General?.codeLabels["cm_add_more"]?.label
                  : "ADD MORE DOCUMENTS"}
              </ButtonSecondary>
            </div>
          </Label>
          <hr
            style={{
              gridColumn: "1 / span 2",
              width: "100%",
              backgroundColor: "#101E8E",
              mixBlendMode: "normal",
              opacity: "0.2",
            }}
          />
           <div
            style={{
              display: "flex",
              flexDirection: General?.isLargeScreen ? "row" : "column",
              gap: "2rem",
              marginTop: "1rem",
            }}
          >
           <ButtonSecondary
              style={{
                width: General?.isLargeScreen ? "168px" : "98%",
                height: "50px",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#fff",
                border: `1px solid ${
                  contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss
                }`,
              }}
              onClick={Previous}
            >
              {General?.codeLabels["cm_back"]?.label || "BACK"}
            </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen ? "168px" : "98%",
              height: "50px",
              background: General?.contrast?.contrastColor
                ? General?.contrast?.contrastColor
                : "#101e8e",
              color: General?.contrast?.contrastBackground
                ? General?.contrast?.contrastBackground
                : "#fff",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "16px",
            }}
            onClick={handleSubmit}
          >
            {showLoader ? (
              <Spinner width="30px" height="30px" />
            ) : General?.codeLabels["cm_submit"]?.label !== undefined ? (
              General?.codeLabels["cm_submit"]?.label
            ) : (
              "SUBMIT"
            )}
          </ButtonSecondary>
          </div>
        </TabContainer>
      </>
    );
  }
);

export default FileUpload;
